import Dashboard from '@material-ui/icons/Dashboard';
// import HotTubIcon from "@material-ui/icons/HotTub";
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks'
import ListAltIcon from '@material-ui/icons/ListAlt';
import Orders from './views/CategoryTable/DriverOrdersTableList.js';
// core components/views for Admin layout
import DashboardPage from './views/Dashboard/Dashboard.js';
import DriverDashboard from './views/Dashboard/DriverDashboard.js';
import TableListCategories from './views/Vendor/CategoryTableList.js';
// import Products from "./views/Product/ProductTable.js";

const dashboardRoutes = [
  {
    path: '/driver-dashboard',
    name: 'Dashboard',
    rtlName: 'لوحة القيادة',
    icon: Dashboard,
    component: DriverDashboard,
    layout: '/driver',
  },
  {
    path: '/all-orders',
    name: 'My Orders',
    rtlName: '',
    icon: ListAltIcon,
    component: Orders,
    layout: '/driver',
  }
  // {
  //   path: "/products",
  //   name: "Products",
  //   rtlName: "ملف تعريفي للمستخدم",
  //   icon: HotTubIcon,
  //   component: Products,
  //   layout: "/vendor",
  // },
  /*
  {
    path: "/allMenus",
    name: "All Menus",
    rtlName: "قائمة الجدول",
    icon: ListAltIcon,
    component: Menus,
    layout: "/vendor2"
  },
 
  {
    path: "/subCategories",
    name: "All Sub-Categories",
    rtlName: "طباعة",
    icon: DynamicFeedIcon,
    component: SubCategoriesTable,
    layout: "/admin2"
  },
  {
    path: "/vendors",
    name: "All Vendors",
    rtlName: "طباعة",
    icon: HotTubIcon,
    component: VendorsTable,
    layout: "/vendor2"
  },
  /*{
    path: "/icons",
    name: "Icons",
    rtlName: "الرموز",
    icon: BubbleChart,
    component: Icons,
    layout: "/admin2"
  },
  {
    path: "/maps",
    name: "Maps",
    rtlName: "خرائط",
    icon: LocationOn,
    component: Maps,
    layout: "/admin2"
  },
  {
    path: "/notifications",
    name: "Notifications",
    rtlName: "إخطارات",
    icon: Notifications,
    component: NotificationsPage,
    layout: "/admin2"
  }*/
];

export default dashboardRoutes;
